export const logo = {
  entries_screens: require("./logo.png"),
};
